import apiClient from '@api/apiClient';

const getTests = async () => {
  try {
    const response = await apiClient.get('test-types', {middleware: {withAuth: true}});
    const {data} = response || {};
    if (data) {
      return data;
    }
    return [];
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const getTestsFull = async () => {
  try {
    const response = await apiClient.get('test-types/all', {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return [];
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const addTest = async name => {
  try {
    const jsonData = {
      name: name,
    };
    const response = await apiClient.post('test-types', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const editTest = async (name, id) => {
  try {
    const jsonData = {
      name: name,
    };
    const response = await apiClient.put(`test-types/${id}`, jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const deleteTests = async tests_ids => {
  try {
    let params = new URLSearchParams();
    tests_ids.forEach(id => params.append('test_type_ids', id));
    const response = await apiClient.delete('test-types', {
      params: params,
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

export const testsAPI = {
  getTests,
  getTestsFull,
  addTest,
  editTest,
  deleteTests,
};
